import { types, Instance } from 'mobx-state-tree';
const { model, Date } = types;

export const DateRangeModel = model('DateRangeModel', {
  startDate: Date,
  endDate: Date,
});

export type IDateRangeModel = Instance<typeof DateRangeModel>;
